import { render, staticRenderFns } from "./Template55_3.vue?vue&type=template&id=9850d974&scoped=true&"
import script from "./Template55_3.vue?vue&type=script&lang=js&"
export * from "./Template55_3.vue?vue&type=script&lang=js&"
import style0 from "./Template55_3.vue?vue&type=style&index=0&id=9850d974&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9850d974",
  null
  
)

export default component.exports